import {VarAssignmentChunk} from "../../chunks/types/VarAssignmentChunk";

// TODO: Value needs to be parsed (JSON)
export function getVarValueFromVarAssignmentChunk(
  varAssignmentChunk: VarAssignmentChunk
): string {
  const {captures: {2: varValueChunk}, content} = varAssignmentChunk;
  if (varValueChunk) {
    const {captures: [varValue]} = varValueChunk;
    return varValue;
  } else {
    return content || "";
  }
}
